define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ReportCallbackPayload = void 0;
    var ReportCallbackPayload;
    (function (ReportCallbackPayload) {
        let type;
        (function (type) {
            type["COM_CIPTEX_BOOKING_COMPLETED"] = "com.ciptex.booking.completed";
        })(type = ReportCallbackPayload.type || (ReportCallbackPayload.type = {}));
    })(ReportCallbackPayload = exports.ReportCallbackPayload || (exports.ReportCallbackPayload = {}));
});
